import { markOnboardingComplete } from './onboardingStorage';

/**
 * Escape hatch when the `/onboarding` remote fails to load/mount.
 * Marks the current user complete (when known) and navigates home so a bad
 * module deploy cannot lock users on the error page.
 *
 * Comment out the `onModuleError={...}` wiring in `App.tsx` to observe the
 * standard RemoteAppShell error page instead of this redirect.
 */
export function handleOnboardingModuleLoadFailure(
  userId: string | undefined | null,
  navigateHome: () => void
): void {
  if (userId) {
    markOnboardingComplete(userId);
  }
  navigateHome();
}
